/* eslint-disable max-lines */
/* eslint-disable complexity */
/* eslint-disable max-statements */
import { fromJS } from 'immutable';
import {
  DateSplitter,
  SortCodeSplitter,
  convertStringToYesNo,
  getAddressPrefix,
  getQueryStringValueByName
} from '../../utils';
import { STORE_BUSINES_TYPE, SAVE_BUSINESS_FORM_VALUES, ON_CANCEL_EDIT_CLICK } from './actions';
import {
  BUSINESS_TYPE,
  CASE_ID,
  CASE_SUBTYPE,
  DATA_FROM_BUSINESS_ACCOUNT,
  BANK_ID,
  BRAND_ID,
  BUSINESS_UUID,
  REGISTER_ADDRESS_TYPE,
  TRADING_ADDRESS_TYPE,
  MAILING_ADDRESS_TYPE
} from '../../utils/constants';
import { postCodeFormat } from '../../components/Address/addressUtils/addressUtils';
import {
  FETCH_CUSTOMERBYID_SUCCESS,
  FETCH_CUSTOMERS_SUCCESS
} from '../../infrastructure/customers';
import { getRegisterCompanyName, getRegisterCompanyNumber } from './reducerUtils';
const enterDifferentAddress = 'Enter a different address';
const No = 'No';
const Yes = 'Yes';
const EMAIL = 'EMAIL';
const MESSAGING = 'MESSAGING';
const INTERNET_BANKING = 'INTERNET_BANKING';
const VOICE = 'VOICE';
const POST = 'POST';
const limitedCompany = 'Limited Company';

const REGISTER_ADDRESS_SELECTION = 'register_ADDRESS_SELECTION';
const TRADING_ADDRESS_SELECTION = 'trading_ADDRESS_SELECTION';
const MAILING_ADDRESS_SELECTION = 'mailing_ADDRESS_SELECTION';

export const initialState = fromJS({
  loading: false,
  marketingLoader: false,
  registerAddressSelector: '',
  registerEditClick: true,
  tradingEditClick: true,
  mailingEditClick: true,
  isOpen: false
});

const mapCustomerDetails = (data) =>
  Object.assign(
    {
      registeredName: getRegisterCompanyName(data),
      businessTypeField: data.business_details.type,
      registeredNumber: getRegisterCompanyNumber(data),
      tradingName: data.business_details.trading_name,
      industryType: data.business_details.industry_type,
      industryDescription: data.business_details.industry_description,
      numberOfPeople: data.business_details.no_of_employees,
      needLicence: data.business_details.need_business_licence !== 'No' ? 'Yes' : 'No',
      typeOfLicense: data.business_details.need_business_licence,
      activityTypes: data.business_details.business_activity_type,
      annualSales: data.business_details.financial_info.annual_sales_turnover,
      costToStartBusiness: data.business_details.financial_info.cost_to_start_business,
      fundsToStartBusiness: data.business_details.financial_info.business_startup_funds_source,
      incorporationDate: DateSplitter(data.business_details.registered_company.incorporation_date),
      beginTrading: DateSplitter(data.business_details.begin_trading_date),
      anotherBankAccount:
        data.business_details.account_with_other_bank === 'Y'
          ? convertStringToYesNo('Y')
          : convertStringToYesNo('N'),
      switchingBankAccount:
        data.business_details.hasOwnProperty('switch_account') &&
        data.business_details.switch_account.hasOwnProperty('account_number')
          ? convertStringToYesNo('Y')
          : convertStringToYesNo('N'),
      accountNumber:
        data.business_details.hasOwnProperty('switch_account') &&
        data.business_details.switch_account.hasOwnProperty('account_number')
          ? data.business_details.switch_account.account_number
          : null,
      hasTaxObligation: convertStringToYesNo(
        data.business_details.financial_info.tax_info.uk_taxpayer_only
      ),
      taxList: getTaxInfo(data.business_details.financial_info.tax_info),
      sortCode:
        data.business_details.hasOwnProperty('switch_account') &&
        data.business_details.switch_account.hasOwnProperty('sort_code')
          ? SortCodeSplitter(data.business_details.switch_account.sort_code)
          : null,
      confirmAllTaxObligation: getConfirmObligation(data),
      incomeFromBusiness: taxEntityType(
        data.business_details.financial_info.tax_info.tax_entity_type
      ),
      businessNumber:
        data.business_details.contact_details.phone.work ||
        data.business_details.contact_details.phone.mobile,
      emailAddress: data.business_details.contact_details.email,
      preferredContactMethod: data.business_details.contact_details.preferred_contact
    },
    getAllAddresses(data)
  );

const getAllAddresses = (data) => {
  const tradingAddressField =
    data.business_details.addresses[0] !== undefined &&
    data.business_details.addresses[0].uk_address;
  const mailingAddressField =
    data.business_details.addresses[1] !== undefined &&
    data.business_details.addresses[1].uk_address;
  const tradingPrefix =
    tradingAddressField && tradingAddressField.address_prefix
      ? getAddressPrefix(tradingAddressField.address_prefix)
      : '';
  const mailingPrefix =
    mailingAddressField && mailingAddressField.address_prefix
      ? getAddressPrefix(mailingAddressField.address_prefix)
      : '';
  return Object.assign(
    {
      tradingAddress: data.business_details.type === limitedCompany ? enterDifferentAddress : No,
      mailingAddress: enterDifferentAddress,
      tradingAddressIsUkResident: tradingAddressField ? Yes : No,
      mailingAddressIsUkResident: mailingAddressField ? Yes : No,
      selectedTradingId:
        tradingAddressField && tradingAddressField.id ? tradingAddressField.id : '',
      tradingOrganisationName:
        tradingAddressField && tradingAddressField.organisation_name
          ? tradingAddressField.organisation_name
          : '',
      tradingAddressFlatNumber: tradingPrefix && tradingPrefix[0],
      tradingAddressBuildingNumber:
        tradingAddressField && tradingAddressField.house_number
          ? tradingAddressField.house_number
          : '',
      tradingAddressStreetName:
        tradingAddressField && tradingAddressField.street_name
          ? tradingAddressField.street_name
          : '',
      tradingAddressCityName:
        tradingAddressField && tradingAddressField.city ? tradingAddressField.city : '',
      tradingAddressPostcode:
        tradingAddressField && tradingAddressField.postal_code
          ? tradingAddressField.postal_code
          : '',
      tradingAddressLine1:
        tradingAddressField && tradingAddressField.address_line_1
          ? tradingAddressField.address_line_1
          : '',
      tradingAddressLine2:
        tradingAddressField && tradingAddressField.address_line_2
          ? tradingAddressField.address_line_2
          : '',
      tradingAddressHouseName: tradingPrefix && tradingPrefix[1],
      tradingAddressReference:
        tradingAddressField && tradingAddressField.id ? tradingAddressField.id : '',
      selectedMailingId:
        mailingAddressField && mailingAddressField.id ? mailingAddressField.id : '',
      mailingOrganisationName:
        mailingAddressField && mailingAddressField.organisation_name
          ? mailingAddressField.organisation_name
          : '',
      mailingAddressFlatNumber: mailingPrefix && mailingPrefix[0],
      mailingAddressBuildingNumber:
        mailingAddressField && mailingAddressField.house_number
          ? mailingAddressField.house_number
          : '',
      mailingAddressStreetName:
        mailingAddressField && mailingAddressField.street_name
          ? mailingAddressField.street_name
          : '',
      mailingAddressCityName:
        mailingAddressField && mailingAddressField.city ? mailingAddressField.city : '',
      mailingAddressPostcode:
        mailingAddressField && mailingAddressField.postal_code
          ? mailingAddressField.postal_code
          : '',
      mailingAddressLine1:
        mailingAddressField && mailingAddressField.address_line_1
          ? mailingAddressField.address_line_1
          : '',
      mailingAddressLine2:
        mailingAddressField && mailingAddressField.address_line_2
          ? mailingAddressField.address_line_2
          : '',
      mailingAddressHouseName: mailingPrefix && mailingPrefix[1],
      mailingAddressReference:
        mailingAddressField && mailingAddressField.id ? mailingAddressField.id : ''
    },
    getRegisterAddress(data)
  );
};

const getRegisterAddress = (data) => {
  if (data.business_details.type === limitedCompany) {
    const registerAddressField = data.business_details.registered_company.uk_address;
    const addressPrefix = getAddressPrefix(registerAddressField.address_prefix);
    return {
      registeredAddress: No,
      selectedRegisterId: registerAddressField.id,
      registeredOrganisationName: registerAddressField.organisation_name,
      registeredAddressFlatNumber: addressPrefix && addressPrefix[0],
      registeredAddressBuildingNumber: registerAddressField.house_number,
      registeredAddressStreetName: registerAddressField.street,
      registeredAddressCityName: registerAddressField.city,
      registeredAddressPostcode: registerAddressField.postal_code,
      registeredAddressCountyName: registerAddressField.county,
      registeredAddressLine1: registerAddressField.address_line_1,
      registeredAddressLine2: registerAddressField.address_line_2,
      registeredAddressHouseName: addressPrefix && addressPrefix[1],
      registeredAddressReference: registerAddressField.id
    };
  }
  return '';
};

const mapPreferenceDetails = (marketPreferences) => {
  const email = marketPreferences.find((preference) => preference.type === EMAIL);
  const message = marketPreferences.find((preference) => preference.type === MESSAGING);
  const internetBanking = marketPreferences.find(
    (preference) => preference.type === INTERNET_BANKING
  );
  const voice = marketPreferences.find((preference) => preference.type === VOICE);
  const post = marketPreferences.find((preference) => preference.type === POST);
  return {
    gdprEmailField: email !== undefined && convertStringToYesNo(email.value),
    gdprInternetField: internetBanking !== undefined && convertStringToYesNo(internetBanking.value),
    gdprMessagingField: message !== undefined && convertStringToYesNo(message.value),
    gdprPhoneField: voice !== undefined && convertStringToYesNo(voice.value),
    gdprPostField: voice !== undefined && convertStringToYesNo(post.value)
  };
};

const getTaxInfo = (tax_info) => {
  return tax_info.identification_info.map((info) => {
    return {
      countryField: info.country_of_residency,
      taxNumber: info.number,
      hasTaxNumber: info.hasOwnProperty('number') ? 'Yes' : 'No'
    };
  });
};
const taxEntityType = (confirmAllTaxObligation) => {
  const confirmObligation = confirmAllTaxObligation
    ? confirmAllTaxObligation === 'Non-Financial Institution'
      ? 'Yes'
      : 'No'
    : '';
  return confirmObligation;
};

const getConfirmObligation = (data) => {
  const taxInfo = data.business_details.financial_info.tax_info;
  return taxInfo && taxInfo.identification_info.length !== 0
    ? taxInfo.identification_info.length > 0
      ? 'Yes'
      : 'No'
    : '';
};

let dataCaptureCopy = {
  registerEditClick: true,
  tradingEditClick: true,
  mailingEditClick: true,
  registerAddressSelector: '',
  mutipleAddressTrading: '',
  mutipleAddressMailing: '',
  register: {},
  trading: {},
  mailing: {}
};

export default function saveFormData(state = initialState, action) {
  if (action.type && action.type.indexOf('SAVE_') === 0) {
    dataCaptureCopy = Object.assign({}, dataCaptureCopy, action.data);
    return state.merge(fromJS(action.data));
  }
  if (action.type && action.type === 'FETCH_BUSINESS_CUSTOMERSBYID_SUCCESS') {
    dataCaptureCopy = Object.assign({}, dataCaptureCopy, mapCustomerDetails(action.payload));
    return state
      .merge(fromJS(mapCustomerDetails(action.payload)))
      .set('customerData', fromJS(action.payload));
  }
  if (action.type && action.type === FETCH_CUSTOMERBYID_SUCCESS) {
    return state
      .merge(fromJS(mapCustomerDetails(action.payload)))
      .set('customerData', fromJS(action.payload));
  }
  if (action.type && action.type === 'FETCH_MARKETING_PREFERENCES_SUCCESS') {
    return state.merge(fromJS(mapPreferenceDetails(action.payload.marketing_preferences)));
  }
  if (action.type && action.type === FETCH_CUSTOMERS_SUCCESS) {
    return state.set('business_uuid', fromJS(action.payload.customers[0].id));
  }
  if (action.type) {
    if (action.type.indexOf('SAVE_') === 0) {
      dataCaptureCopy = Object.assign({}, dataCaptureCopy, action.data);
      return state.merge(fromJS(action.data));
    } else if (action.type === 'SUBMIT_GDPR_FORM_SUCCESS') {
      return state.merge(fromJS(action.payload)).set('marketingLoader', false);
    } else if (action.type === 'SUBMIT_GDPR_FORM') {
      return state.merge(fromJS(action.data)).set('marketingLoader', true);
    } else if (action.type === 'SUBMIT_GDPR_FORM_FAILED') {
      return state.merge(fromJS(action.data)).set('marketingLoader', false);
    } else if (action.type === 'SUBMIT_FORM_SUCCESS') {
      return state.set(BUSINESS_UUID, action.payload.id);
    } else if (action.type === STORE_BUSINES_TYPE) {
      return state.set(DATA_FROM_BUSINESS_ACCOUNT, {
        BUSINESS_TYPE: getQueryStringValueByName(BUSINESS_TYPE),
        CASE_ID: getQueryStringValueByName(CASE_ID),
        CASE_SUBTYPE: getQueryStringValueByName(CASE_SUBTYPE),
        BANK_ID: getQueryStringValueByName(BANK_ID),
        BRAND_ID: getQueryStringValueByName(BRAND_ID)
      });
    } else if (action.type === 'FETCH_CASE_SUCCESS') {
      return state
        .set('businessTypeField', action.payload.product && action.payload.product.variant)
        .set(BUSINESS_UUID, action.payload.customer_id.business);
    } else if (action.type === 'TOGGLE_GDPR_MODAL') {
      return state.set('isOpen', action.isOpen);
    }
    return onAddressSelection(action, state);
  }
  return state;
}

const onAddressSelection = (action, state) => {
  if (action.type === REGISTER_ADDRESS_SELECTION) {
    return state.set('registerAddressSelector', action.data);
  } else if (action.type === TRADING_ADDRESS_SELECTION) {
    return state.set('mutipleAddressTrading', action.data);
  } else if (action.type === MAILING_ADDRESS_SELECTION) {
    return state.set('mutipleAddressMailing', action.data);
  } else if (action.type === SAVE_BUSINESS_FORM_VALUES) {
    return saveAboutFormValues(action.data.name, action.data.value, state);
  }
  return onAddressEditClick(action, state);
};

const onAddressEditClick = (action, state) => {
  if (action.type === 'registerADDRESS_EDIT_CLICK') {
    return state.set('registerEditClick', action.data);
  } else if (action.type === 'tradingADDRESS_EDIT_CLICK') {
    return state.set('tradingEditClick', action.data);
  } else if (action.type === 'mailingADDRESS_EDIT_CLICK') {
    return state.set('mailingEditClick', action.data);
  }
  return onCancelEditClick(action, state);
};

const onCancelEditClick = (action, state) => {
  if (action.type === ON_CANCEL_EDIT_CLICK) {
    return state.merge(dataCaptureCopy);
  }
  return state;
};

const saveAboutFormValues = (name, formValue, state) => {
  let value = formValue;
  if (name.indexOf('postcode') > -1) {
    value = postCodeFormat(formValue);
  }
  if (isAddress(name)) {
    const splited_name = name.split('.');
    const dataCapture = state.toJS();
    let data;
    if (splited_name.length === 2) {
      data = dataCapture[splited_name[0]] || {};
      data[splited_name[1]] = value;
    } else {
      data = dataCapture[splited_name[0]] || {};
      data[splited_name[2]]
        ? (data[splited_name[1]][splited_name[2]] = value)
        : (data[splited_name[1]] = Object.assign({}, data[splited_name[1]], {
            [splited_name[2]]: value
          }));
    }
    return state.set(splited_name[0], data, splited_name[1][splited_name[1]]);
  }
  return name ? state.set(name, value) : state;
};

const isAddress = (name) =>
  name.indexOf(`${REGISTER_ADDRESS_TYPE}.`) > -1 ||
  name.indexOf(`${TRADING_ADDRESS_TYPE}.`) > -1 ||
  name.indexOf(`${MAILING_ADDRESS_TYPE}.`) > -1 ||
  name.indexOf('incorporationDate') > -1;
